@if (viewState() === 'content') {
  <div class="blast-environment" [class.blast-environment--mobile]="device.isMobile()">

    <!-- ── Panel gauche : Chart CO2 ─────────────────────────────────────── -->
    <div class="blast-environment__panel">
      <app-panel [title]="'ENVIRONMENT.EMISSION_CO2' | translate">
        <div class="co2-chart-section">
          <div class="donut-chart-container">
            <div class="donut-chart" [style.background]="getDonutGradient()">
              <div class="donut-hole">
                <span class="total-value">{{ co2Summary().total | number:'1.0-0' }} kg</span>
                <span class="total-label">{{ 'RECORD.TOTAL' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="chart-legend">
            @for (category of co2Summary().categories; track category) {
              <div class="legend-item">
                <span class="legend-color" [style.background-color]="category.color"></span>
                <span class="legend-label">{{ category.translationKey | translate }}</span>
                <span class="legend-percentage">{{ category.percentage | number:'1.0-1' }}%</span>
              </div>
            }
          </div>
        </div>
      </app-panel>
    </div>

    <!-- ── Tableaux ──────────────────────────────────────────────────────── -->
    <div class="blast-environment__main">
      <app-scrollable [enabled]="!device.isMobile()">
        <div class="data-card">
          <h4 class="card-title">{{ 'ENVIRONMENT.TRANSPORT' | translate }}</h4>
          <div class="m-25">
            <app-data-table [data]="transportTableData()" [columns]="transportColumns"
              [equalColumns]="true"
              sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
              sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
              sortIconFilter="brightness(0)" />
          </div>
        </div>
        <div class="data-card">
          <h4 class="card-title">{{ 'ENVIRONMENT.DRILLING' | translate }}</h4>
          <div class="m-25">
            <app-data-table [data]="drillingTableData()" [columns]="drillingColumns"
              [equalColumns]="true"
              sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
              sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
              sortIconFilter="brightness(0)" />
          </div>
        </div>
        <div class="data-card">
          <h4 class="card-title">{{ 'ENVIRONMENT.DETONATION' | translate }}</h4>
          <div class="m-25">
            <app-data-table [data]="detonationsTableData()" [columns]="productColumns"
              [equalColumns]="true"
              sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
              sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
              sortIconFilter="brightness(0)" />
          </div>
        </div>
        <div class="data-card">
          <h4 class="card-title">{{ 'ENVIRONMENT.PRODUCTION' | translate }}</h4>
          <div class="m-25">
            <app-data-table [data]="productsTableData()" [columns]="productColumns"
              [equalColumns]="true"
              sortAscIcon="assets/icon/new_icon/arrow_full_down.svg"
              sortDescIcon="assets/icon/new_icon/arrow_full_up.svg"
              sortIconFilter="brightness(0)" />
          </div>
        </div>
      </app-scrollable>
    </div>

  </div>
}

@if (viewState() === 'loading') {
  <div class="loading-container">
    <i class="fas fa-spinner fa-spin"></i>
    <span>{{ 'GLOBAL.CHARGEMENT' | translate }}...</span>
  </div>
}

@if (viewState() === 'empty') {
  <div class="empty-container">
    <p>{{ 'ENVIRONMENT.NO_DATA' | translate }}</p>
  </div>
}
